import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router";
import { sectionForPath } from "@/lib/section";
import { useAgentStore } from "@/stores/agent-store";

// Shows above the composer which Studio notebook rides along with every message, so the hand-over is
// visible rather than implied (@external-adr AGENT-SERVICE-0036-the-studio-proposes-records-the-user-decides).
export function StudioNotebookChip() {
  const notebook = useAgentStore((s) => s.studioNotebook);
  const { pathname } = useLocation();
  if (!notebook || sectionForPath(pathname) !== "save/studio") return null;
  return (
    <div className="mb-2 flex flex-wrap gap-1.5">
      <span className="box-flat inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-smycles-meta text-ink">
        <FormattedMessage
          id="agent.studioNotebook.chip"
          defaultMessage="Notebook “{name}”"
          values={{ name: notebook.name }}
        />
      </span>
    </div>
  );
}
